import * as React from 'react'
import { logger } from './logging'
import * as ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { StrictMode } from 'react'

const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement!)
// According to environment variable MYTMPVPN_USEMOCKS use 
// Amplify or AmplifyMock
if (process.env.MYTMPVPN_USEMOCKS === 'true') {
    const { AmplifyMock } = await import('./__mocks__/aws-amplify')
    AmplifyMock.configure()
    logger.warn('Using mocks! This is a fake environment!')
} else {
    // Yes, this is a bit complicated. It turns out that:
    // 1. aws-exports has no type, but exposes a default module exports
    // 2. To dynamilly load the module and access the default value that is required 
    //    for amplify init, we need to use this syntax. 
    const aws_config: any = (await import('./aws-exports')).default
    const { Amplify } = await import('aws-amplify')
    Amplify.configure(aws_config)
    logger.info('Using real environment!')
}

root.render(
    <StrictMode>
        <App />
    </StrictMode>
)